/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { RowsStore } from '../stores';

export const RowsContext = createContext<RowsStore>({} as RowsStore);
